/* ==========================================================================
   Kayak Merkezleri — başlık, arama ve sepet etkileşimleri.
   Bağımlılık yok. Fiyat biçimi ve ürün verisi hep Liquid'den gelir; burada
   fiyat hesabı ya da para birimi biçimlendirmesi yapılmaz.
   ========================================================================== */
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* ---------------------------------------------------------------- yardımcı */

  function lockScroll(on) {
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }

  /** Katman açıkken Tab'ı katmanın içinde tutar. */
  function trapFocus(layer, event) {
    var nodes = Array.prototype.filter.call(layer.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!nodes.length) return;

    var first = nodes[0];
    var last = nodes[nodes.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /**
   * Açılır katman (arama / sepet) için ortak davranış:
   * aç, kapat, Esc, odak yönetimi, kaydırma kilidi.
   */
  function createLayer(layer) {
    var opener = null;

    function onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      } else if (event.key === 'Tab') {
        trapFocus(layer, event);
      }
    }

    function open(trigger) {
      if (!layer.hidden) return;
      opener = trigger || null;
      layer.hidden = false;
      lockScroll(true);
      document.addEventListener('keydown', onKeydown);

      var target = layer.querySelector('[data-km-autofocus]') || layer.querySelector(FOCUSABLE);
      if (target) target.focus();
    }

    function close() {
      if (layer.hidden) return;
      layer.hidden = true;
      lockScroll(false);
      document.removeEventListener('keydown', onKeydown);
      if (opener && document.contains(opener)) opener.focus();
      opener = null;
    }

    return { open: open, close: close, isOpen: function () { return !layer.hidden; } };
  }

  /* ------------------------------------------------------------- açılır menü */

  function initMenu() {
    var toggle = document.querySelector('[data-km-menu-toggle]');
    var panel = document.getElementById('km-menu-panel');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    });

    // Masaüstü genişliğine dönünce panel açık kalmasın.
    window.addEventListener('resize', function () {
      if (getComputedStyle(toggle).display === 'none' && !panel.hidden) {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* -------------------------------------------------------------- arama katmanı */

  function initSearch() {
    var layer = document.querySelector('[data-km-search-layer]');
    if (!layer) return;

    var control = createLayer(layer);
    var input = layer.querySelector('[data-km-search-input]');
    var results = layer.querySelector('[data-km-search-results]');
    var suggest = layer.querySelector('[data-km-search-suggest]');
    var timer = null;
    var lastQuery = '';
    var controller = null;

    if (input) input.setAttribute('data-km-autofocus', '');

    document.querySelectorAll('[data-km-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Menü panelini kapat, arama üstüne binmesin.
        var panel = document.getElementById('km-menu-panel');
        var toggle = document.querySelector('[data-km-menu-toggle]');
        if (panel && !panel.hidden) {
          panel.hidden = true;
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }
        control.open(btn);
      });
    });

    layer.querySelectorAll('[data-km-search-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        control.close();
      });
    });

    layer.querySelectorAll('[data-km-search-fill]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (!input) return;
        input.value = chip.getAttribute('data-km-search-fill') || '';
        input.focus();
        run();
      });
    });

    function setSuggestVisible(visible) {
      if (suggest) suggest.hidden = !visible;
    }

    function run() {
      if (!input || !results) return;
      var q = input.value.trim();

      if (q.length < 2) {
        results.innerHTML = '';
        setSuggestVisible(true);
        lastQuery = '';
        return;
      }
      if (q === lastQuery) return;
      lastQuery = q;
      setSuggestVisible(false);

      if (controller) controller.abort();
      controller = new AbortController();

      var url =
        '/search/suggest?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&section_id=predictive-search';

      fetch(url, { signal: controller.signal })
        .then(function (res) {
          if (!res.ok) throw new Error('Arama başarısız: ' + res.status);
          return res.text();
        })
        .then(function (html) {
          results.innerHTML = html;
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          // Sessizce yutma — sonuç gelmediyse kullanıcı bunu bilmeli.
          results.innerHTML =
            '<div class="km-search__empty"><p>Arama şu an yanıt vermedi. Bağlantını kontrol edip tekrar dene.</p></div>';
          console.error('[km] canlı arama hatası', err);
        });
    }

    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(run, 250);
      });
    }
  }

  /* ------------------------------------------------------------ sepet çekmecesi */

  function initCart() {
    var drawer = document.querySelector('[data-km-cart-drawer]');
    if (!drawer) return;

    var control = createLayer(drawer);
    var busy = false;

    function bindCloseButtons() {
      drawer.querySelectorAll('[data-km-cart-close]').forEach(function (btn) {
        if (btn.dataset.kmBound) return;
        btn.dataset.kmBound = '1';
        btn.addEventListener('click', function () {
          control.close();
        });
      });
    }

    document.querySelectorAll('[data-km-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        control.open(btn);
      });
    });

    bindCloseButtons();

    /**
     * Sepet değiştikten sonra çekmeceyi ve sayacı Liquid'den yeniden basar.
     * Section Rendering API kullanılıyor; fiyatlar sunucudan biçimli gelir.
     */
    function refresh() {
      return fetch(window.location.pathname + '?section_id=header', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Sepet yenilenemedi: ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var freshDrawer = doc.querySelector('[data-km-cart-drawer]');
          if (freshDrawer) {
            // Sarmalayıcıyı koru (hidden durumu ve odak yönetimi orada).
            drawer.innerHTML = freshDrawer.innerHTML;
            bindCloseButtons();
          }

          var freshCount = doc.querySelector('[data-km-cart-count]');
          var count = document.querySelector('[data-km-cart-count]');
          if (freshCount && count) count.textContent = freshCount.textContent;
        });
    }

    function fail(err) {
      console.error('[km] sepet hatası', err);
      alert('Sepet güncellenemedi. Sayfayı yenileyip tekrar dener misin?');
    }

    // Adet değiştir / satır kaldır (olay delegasyonu — içerik yeniden basılıyor).
    drawer.addEventListener('click', function (event) {
      var qtyBtn = event.target.closest('[data-km-qty]');
      if (qtyBtn) {
        event.preventDefault();
        if (busy) return;
        busy = true;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: Number(qtyBtn.getAttribute('data-km-qty')),
            quantity: Number(qtyBtn.getAttribute('data-km-qty-value')),
          }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('change.js ' + res.status);
            return refresh();
          })
          .catch(fail)
          .finally(function () {
            busy = false;
          });
        return;
      }

      var addBtn = event.target.closest('[data-km-add]');
      if (addBtn) {
        event.preventDefault();
        if (busy) return;
        busy = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(addBtn.getAttribute('data-km-add')), quantity: 1 }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add.js ' + res.status);
            return refresh();
          })
          .catch(fail)
          .finally(function () {
            busy = false;
          });
      }
    });

    // Ürün sayfasındaki "Sepete ekle" formları çekmeceyi açar.
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-km-add-form]');
      if (!form) return;
      event.preventDefault();
      if (busy) return;
      busy = true;

      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error(data.description || 'add.js ' + res.status);
            });
          }
          return refresh();
        })
        .then(function () {
          control.open(submitBtn);
        })
        .catch(function (err) {
          console.error('[km] sepete ekleme hatası', err);
          alert(err.message || 'Ürün sepete eklenemedi.');
        })
        .finally(function () {
          busy = false;
          if (submitBtn) submitBtn.removeAttribute('aria-busy');
        });
    });
  }

  /* ---------------------------------------------------------- koleksiyon filtresi */

  function initFilters() {
    var form = document.querySelector('[data-km-filter-form]');
    var panel = document.querySelector('[data-km-filter-panel]');

    // Mobil sheet aç/kapa
    if (panel) {
      document.querySelectorAll('[data-km-filter-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          panel.classList.add('is-open');
          lockScroll(true);
          var close = panel.querySelector('[data-km-filter-close]');
          if (close) close.focus();
        });
      });

      panel.querySelectorAll('[data-km-filter-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          panel.classList.remove('is-open');
          lockScroll(false);
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && panel.classList.contains('is-open')) {
          panel.classList.remove('is-open');
          lockScroll(false);
        }
      });
    }

    if (!form) return;

    // Onay kutusu / sıralama değişince formu gönder (Shopify kendi filtreliyor).
    function submitForm() {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }

    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-km-price-range]')) return; // aşağıda ayrı ele alınıyor
      submitForm();
    });

    // form="km-filter-form" ile forma bağlı ama DOM'da dışarıda duran alanlar.
    document.querySelectorAll('[form="km-filter-form"]').forEach(function (el) {
      el.addEventListener('change', submitForm);
    });

    // Fiyat kaydırıcısı: sürerken etiketi güncelle, bırakınca gönder.
    var range = form.querySelector('[data-km-price-range]');
    var label = form.querySelector('[data-km-price-label]');
    if (range) {
      if (label) {
        var fmt = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 });
        range.addEventListener('input', function () {
          // Yalnızca sürükleme sırasındaki anlık etiket; sayfa yenilenince
          // değeri Liquid'deki price snippet'i basar.
          label.textContent = fmt.format(Number(range.value)) + ' TL';
        });
      }
      range.addEventListener('change', submitForm);
    }
  }

  /* ------------------------------------------------- yazı içindekiler listesi */

  function initArticleToc() {
    var toc = document.querySelector('[data-km-toc]');
    var list = document.querySelector('[data-km-toc-list]');
    var content = document.querySelector('[data-km-article-content]');
    if (!toc || !list || !content) return;

    var headings = content.querySelectorAll('h2');
    if (!headings.length) return; // başlık yoksa liste hiç görünmesin

    headings.forEach(function (heading, index) {
      if (!heading.id) heading.id = 'bolum-' + (index + 1);

      var link = document.createElement('a');
      link.className = 'km-guide__toc-link';
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      list.appendChild(link);
    });

    toc.hidden = false;
  }

  /* ------------------------------------------------- politikalar sekmeleri */

  function initPolicyTabs() {
    var items = document.querySelectorAll('[data-km-policy]');
    var tabs = document.querySelectorAll('[data-km-policy-tab]');
    if (!items.length || !tabs.length) return;

    var titleEl = document.querySelector('[data-km-policy-title]');
    var leadEl = document.querySelector('[data-km-policy-lead]');
    var crumbEl = document.querySelector('[data-km-policy-crumb]');
    var kickerEl = document.querySelector('[data-km-policy-kicker]');

    function show(key) {
      var matched = false;

      items.forEach(function (item) {
        var on = item.getAttribute('data-km-policy') === key;
        item.hidden = !on;
        if (on) matched = true;
      });

      // Hash tanınmadıysa ilk politikayı göster.
      if (!matched) {
        items[0].hidden = false;
        key = items[0].getAttribute('data-km-policy');
      }

      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-km-policy-tab') === key;
        tab.classList.toggle('is-active', on);
        if (on) {
          if (titleEl) titleEl.textContent = tab.getAttribute('data-km-policy-title-text') || titleEl.textContent;
          if (crumbEl) crumbEl.textContent = tab.getAttribute('data-km-policy-title-text') || crumbEl.textContent;

          var lead = tab.getAttribute('data-km-policy-lead-text');
          if (leadEl && lead) leadEl.textContent = lead;

          var kicker = tab.getAttribute('data-km-policy-kicker-text');
          if (kickerEl && kicker) kickerEl.textContent = kicker;
        }
      });
    }

    show(window.location.hash.slice(1));
    window.addEventListener('hashchange', function () {
      show(window.location.hash.slice(1));
    });
  }

  /* ------------------------------------------------ bota karşı korumalı e-posta */

  function initSafeEmail() {
    document.querySelectorAll('[data-km-email]').forEach(function (el) {
      var user = el.getAttribute('data-km-email-user');
      var domain = el.getAttribute('data-km-email-domain');
      if (!user || !domain) return;

      var address = user + '@' + domain;
      var link = document.createElement('a');
      link.href = 'mailto:' + address;
      link.textContent = el.getAttribute('data-km-email-label') || address;
      link.className = 'km-email__link';
      link.rel = 'nofollow';

      el.replaceWith(link);
    });

    // Kartın tamamı e-posta bağlantısıysa href'i burada kuruyoruz — içine
    // ayrıca <a> koyamayız, bağlantı içinde bağlantı geçersiz HTML.
    document.querySelectorAll('[data-km-email-card]').forEach(function (card) {
      var user = card.getAttribute('data-km-email-user');
      var domain = card.getAttribute('data-km-email-domain');
      if (!user || !domain) return;
      card.setAttribute('href', 'mailto:' + user + '@' + domain);
      card.setAttribute('rel', 'nofollow');
    });

    // Yalnızca görünen metni düzelt (bağlantı kurma).
    document.querySelectorAll('[data-km-email-text]').forEach(function (el) {
      var user = el.getAttribute('data-km-email-user');
      var domain = el.getAttribute('data-km-email-domain');
      if (!user || !domain) return;
      el.textContent = user + '@' + domain;
    });
  }

  /* ------------------------------------------------------------------- başlat */

  function init() {
    initSafeEmail();
    initMenu();
    initSearch();
    initCart();
    initFilters();
    initArticleToc();
    initPolicyTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
